import { Avatar } from "../../../../../../../../../../../components/Avatar/Avatar";

interface CommentAuthorProps {
  userName?: string;
  showName?: boolean;
  avatarSize?: number;
  avatarClassName?: string;
  nameClassName?: string;
}

export const CommentAuthor = ({
  userName,
  showName = true,
  avatarSize = 18,
  avatarClassName = "text-[8px]! shrink-0",
  nameClassName = "text-md font-medium text-gray-450 dark:text-gray-450-dk overflow-hidden text-ellipsis whitespace-nowrap",
}: CommentAuthorProps) => {
  return (
    <>
      <Avatar size={avatarSize} text={userName} className={avatarClassName} />
      {showName && userName && <p className={nameClassName}>{userName}</p>}
    </>
  );
};
